import React, { use, useEffect, useState } from "react";
import heroBG from "../../assets/LocationPage/demoLocation.png";
import brImg1 from "../../assets/LocationPage/br1.png";
import brImg2 from "../../assets/LocationPage/br2.png";
import p1 from "../../assets/LocationPage/p1.jpeg";
import p2 from "../../assets/LocationPage/p2.png";
import p3 from "../../assets/LocationPage/p3.png";
import "../../styles/LocationPageStyles/locationStyle.css";
import OrderBtn from "../../utils/OrderBtn";
import Map from "../Map/Map";
import Ajax from "../../assets/Locations/Ajax.jpg";
import Testimonials from "../Testimonials";
import Footer from "../Footer";
import doorImg from "../../assets/LocationPage/doordash2.png";
import skipImg from "../../assets/LocationPage/Skip_2024.webp";
import uberImg from "../../assets/LocationPage/ubereats.png";
import { Link, useLocation, useParams } from "react-router";
import Loader from "../../utils/Loader";
import axios from "axios";
import config from "../../config";
import { Card } from "react-bootstrap";
import StaticImg from "../../assets/LocationPage/staticImg.png";
import { Helmet } from "react-helmet";

const LocationsPage = ({ testimonialsList, categoryList }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [locationId, setLocationId] = useState("");
  const [locationData, setLocationData] = useState([]);
  const [showCat, setShowCat] = useState(false);
  const [mapLocation, setMapLocation] = useState([])
  const { location_slug } = useParams();



  const allLocationsData = [
    {
      id: 1,
      name: 'ajax',
      position: [43.85976721, -79.02463306],
    },
    {
      id: 2,
      name: 'halifax',
      position: [44.651070, -63.582687],
    },
    {
      id: 3,
      name: 'lebovic-scarborough',
      position: [43.72383395, -79.29012491],
    },
    {
      id: 4,
      name: 'collingwood',
      position: [44.50199222, -80.23063715],
    },
    {
      id: 5,
      name: 'surrey',
      position: [49.13343371, -122.8458931],
    },
    {
      id: 6,
      name: 'ellerslie-edmonton',
      position: [53.5461, -113.323975],
    },
    {
      id: 7,
      name: 'guelph',
      position: [43.549999, -80.250000],
    },
    {
      id: 8,
      name: 'sherwood-park',
      position: [53.541252, -113.295776],
    },
    {
      id: 9,
      name: 'windsor',
      position: [42.317432, -83.026772],
    },
    {
      id: 10,
      name: 'kitchener',
      position: [43.452969, -80.495064],
    },
    {
      id: 11,
      name: 'kingston',
      position: [44.233334, -76.5],
    },
    {
      id: 12,
      name: 'scarborough',
      position: [43.777702, -79.233238],
    },
    {
      id: 13,
      name: 'north-park-drive-brampton',
      position: [43.683334, -79.76667],
    },
    {
      id: 14,
      name: 'peterborough',
      position: [52.573921, -0.250830],
    },
    {
      id: 15,
      name: 'calgary',
      position: [51.131708, -113.96703],
    },
    {
      id: 16,
      name: 'meadows-edmonton',
      position: [53.454764, -113.377124],
    },
    {
      id: 17,
      name: 'waterloo',
      position: [43.478683, -80.525116],
    },
    {
      id: 18,
      name: 'red-deer',
      position: [52.251498, -113.811775],
    },
    {
      id: 19,
      name: 'vancouver',
      position: [49.2615, -123.101171],
    },
    {
      id: 20,
      name: "kelowna",
      position: [49.8904147423716, -119.497393011222],
    },
    // {
    //   id: 21,
    //   name: "brockville",
    //   position: [44.589413, -75.684512],
    // },
  ]

  const location = [
    {
      id: 1,
      name: "Ajax",
      position: [43.850857, -79.02037],
      address: "11 Harwood Ave S UNIT 104, Ajax, ON L1S 2B9",
      phone: "+1 (647) 421215",
      weekdaysname: "Monday-Thursday:",
      weekdays: " 01:30 PM - 0.5:00 PM",
      weekendname: "Friday-Saturday:",
      weekend: " 12:00 PM - 6:00 AM",
      sundayname: "Sunday:",
      sunday: " 12:00 PM - 1:00 AM",
      image: Ajax,
    },
  ];



  const productsData = [
    {
      id: 1,
      img: locationData?.point1_image ? locationData?.point1_image : p1,
      title: locationData?.point1_title
        ? locationData?.point1_title
        : "The Best Thai Rolled Ice Cream Toronto",
      info: locationData?.point1_description
        ? locationData?.point1_description
        : "Our famous Thai Rolled Ice Cream is available in multiple flavors paired with several delicious toppings and fresh fruits. It is a must try whenever you visit Roll Me Up Ice Cream & Desserts. A perfectly Rolled Ice Cream is your way to happiness.",
    },
    {
      id: 2,
      img: locationData?.point2_image ? locationData?.point2_image : p2,
      title: locationData?.point2_title
        ? locationData?.point2_title
        : "Oh, So Delicious Belgian Waffles",
      info: locationData?.point2_description
        ? locationData?.point2_description
        : "The best Belgian waffles Toronto with Ice cream are now available at Roll Me Up Ice Cream & Desserts. You can enjoy the fluffy bubble waffles with a wide collection of ice cream. Our Bubble Rolled Waffle Toronto is immensely famous, and you would not want to miss out on these.",
    },
    {
      id: 3,
      img: locationData?.point3_image ? locationData?.point3_image : p3,
      title: locationData?.point3_title
        ? locationData?.point3_title
        : "Super Scrumptious Milkshakes in Toronto",
      info: locationData?.point3_description
        ? locationData?.point3_description
        : "A supremely creamy mix of fresh fruits is ready to be served! Check our collection of milkshakes at Roll Me Up Ice Cream & Desserts, and you will not regret it! The decadent milkshakes that we offer are no doubt the perfect blend of flavors.",
    },
  ];



  useEffect(() => {
    const storedLocation = localStorage.getItem("location");
    // setLocationId(storedLocation);
    fetchLocationPage(storedLocation);
  }, [location_slug]);

  useEffect(() => {
    const currentLocation = allLocationsData.find(item => item.name === location_slug)
    setMapLocation(currentLocation)
  }, [location_slug])


  useEffect(() => {
    fetchLocation();
  }, [location_slug]);

  // Fetch LocationPage Data
  const fetchLocationPage = async (locId) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("location", locId);
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/location-data`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLocationData(res.data.data);
        setIsLoading(false);
        // console.log("location page", res.data.data);
      });
    } catch (error) {
      setIsLoading(false);
      console.log("location Page", error);
    }
  };

  const [allLocations, setAllLocations] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState(null);

  // fetch all locations
  const fetchLocation = async () => {
    setIsLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${config.apiUrl}/locations`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setIsLoading(false);
        const locations = res.data.data;
        setAllLocations(locations);
        // console.log("locations cdscds", res.data.data);
        // console.log("lcoation getting", res.data.data)
        const storedLoationId = localStorage.getItem("location");
        // console.log("storedLoationId",storedLoationId)

        if (storedLoationId) {
          const matchLocaion = locations.find(
            (loc) => loc.id.toString() === storedLoationId
          );
          setFilteredLocations(matchLocaion || null);
          // console.log("setFilteredLocations", matchLocaion);
        }
      });
    } catch (error) {
      setIsLoading(false);
      console.log("locations error", error);
    }
  };

  // console.log("FilteredLocations", filteredLocations);
  const metaData = {
    "ajax": {
      keywords: "desserts shop in Ajax, delicious dessert Ajax, dessert places Ajax, best dessert Ajax, popular dessert places in Ajax",
      title: "Best Dessert Places in Ajax - Satisfy Your Sweet Cravings",
      description: "Discover Ajax's top dessert shop for rolled ice cream, milkshakes, waffles, and more. Visit us today!"
    },
    "ellerslie-edmonton": {
      keywords: "desserts shop in Ellerslie Edmonton, delicious dessert Ellerslie Edmonton, dessert places Ellerslie Edmonton, best dessert Ellerslie Edmonton, popular dessert places in Ellerslie Edmonton",
      title: "Best Desserts in Ellerslie Edmonton | Rollz Ice Cream  Sweet Treats",
      description: "Find the most delicious desserts in Ellerslie Edmonton at Rollz Ice Cream! From artisanal ice cream to decadent cakes, we're the top-rated dessert place. Visit us today!"
    },
    "guelph": {
      keywords: "desserts shop in Guelph, delicious dessert Guelph, dessert places Guelph, best dessert Guelph, popular dessert places in Guelph",
      title: "Desserts Guelph | Ice Cream, Waffles, Falooda, More",
      description: "Visit Guelphs top dessert shop for rolled ice cream, Belgian waffles, cheesecake, and more delicious treats."
    },
    "sherwood-park": {
      keywords: "desserts shop in Sherwood Park, delicious dessert Sherwood Park, dessert places Sherwood Park, best dessert Sherwood Park, popular dessert places in Sherwood Park",
      title: "Desserts Sherwood Park | Ice Cream, Waffles & More",
      description: "Discover the best desserts in Sherwood Park at Rollz Ice Cream. Try ice cream, waffles, cheesecake & more treats!"
    },
    "windsor": {
      keywords: "desserts shop in Windsor, delicious dessert Windsor, dessert places Windsor, best dessert Windsor, popular dessert places in Windsor",
      title: "Desserts Windsor | Rolled Ice Cream, Waffles, More",
      description: "Visit the best dessert shop in Windsor for rolled ice cream, Belgian waffles, cheesecake & sweet treats only at Rollz!"
    },
    "kitchener": {
      keywords: "desserts shop in Kitchener, delicious dessert Kitchener, dessert places Kitchener, best dessert Kitchener, popular dessert places in Kitchener",
      title: "Desserts Kitchener | Rolled Ice Cream, Waffles, & More",
      description: "Visit Kitcheners top dessert shop! Try rolled ice cream, Belgian waffles, falooda, and other sweet treats at Rollz Ice Cream."
    },
    "kingston": {
      keywords: "desserts shop in Kingston, delicious dessert Kingston, dessert places Kingston, best dessert Kingston, popular dessert places in Kingston",
      title: "Desserts Kingston | Ice Cream, Waffles & Sweet Treats",
      description: "Discover Kingstons best dessert shop. Rolled ice cream, waffles, milkshakes, and morefreshly served at Rollz!"
    },
    "scarborough": {
      keywords: "desserts shop in Scarborough, delicious dessert Scarborough, dessert places Scarborough, best dessert Scarborough, popular dessert places in Scarborough",
      title: "Dessert places Scarborough | Ice Cream, Falooda, Waffles",
      description: "Rollz Ice Cream is Scarboroughs go-to dessert shop! Enjoy ice cream rolls, waffles, milkshakes & more today."
    },
    "northparkdrive-brampton": {
      keywords: " desserts shop in Brampton, delicious dessert Brampton, dessert places Brampton, best dessert Brampton, popular dessert places in Brampton",
      title: "Desserts Brampton | Rolled Ice Cream, Waffles & More",
      description: "Discover Bramptons favorite dessert shop! Try rolled ice cream, waffles, milkshakes, faloodas, and more at Rollz."
    },
    "peterborough": {
      keywords: " desserts shop in Peterborough, delicious dessert Peterborough, dessert places Peterborough, best dessert Peterborough, popular dessert places in Peterborough",
      title: "Desserts Peterborough | Ice Cream, Waffles & More",
      description: "Satisfy your sweet tooth in Peterborough with the best dessertsrolled ice cream, waffles, cheesecake & more!"
    },
    "calgary": {
      keywords: " desserts shop in Calgary, delicious dessert Calgary, dessert places Calgary, best dessert Calgary, popular dessert places in Calgary",
      title: "Desserts Calgary | Ice Cream, Waffles, Faloodas & More",
      description: "Craving sweet treats in Calgary? Visit Rollz for the best dessertsice cream rolls, waffles, cheesecake, and more!"
    },
    "meadows-edmonton": {
      keywords: " desserts shop in Meadows Edmonton, delicious dessert Meadows Edmonton, dessert places Meadows Edmonton, best dessert Meadows Edmonton, popular dessert places in Meadows Edmonton",
      title: "Desserts Meadows Edmonton | Ice Cream, Falooda & More",
      description: "Visit the top dessert shop in Meadows, Edmonton for rolled ice cream, milkshakes, waffles, and sweet treats!"
    },
    "waterloo": {
      keywords: " desserts shop in Waterloo, delicious dessert Waterloo, dessert places Waterloo, best dessert Waterloo, popular dessert places in Waterloo",
      title: "Desserts Waterloo | Rolled Ice Cream, Faloodas & More",
      description: "Find the best desserts in Waterloo at Rollz! Try ice cream rolls, faloodas, waffles, milkshakes, and more sweet treats."
    },
    "halifax": {
      keywords: " desserts shop in Halifax, delicious dessert Halifax, dessert places Halifax, best dessert Halifax, popular dessert places in Halifax",
      title: "Desserts Halifax | Rolled Ice Cream, Falooda & More",
      description: "Explore the best dessert spot in Halifax. From waffles to milkshakes and faloodassweet cravings meet Rollz!"
    },
    "lebovic-scarborough": {
      keywords: " desserts shop in Scarborough, delicious dessert Scarborough, dessert places Scarborough, best dessert Scarborough, popular dessert places in Scarborough",
      title: "Desserts Scarborough | Rolled Ice Cream, Waffles & More",
      description: "Discover Scarboroughs go-to dessert shop at Lebovic! From faloodas to waffles and milkshakes, we serve it all at Rollz!"
    },
    "collingwood": {
      keywords: " desserts shop in Collingwood, delicious dessert Collingwood, dessert places Collingwood, best dessert Collingwood, popular dessert places in Collingwood",
      title: "Desserts Collingwood | Ice Cream, Waffles, Faloodas & More",
      description: "Visit the best dessert shop in Collingwoodrolled ice cream, cheesecake, waffles & more treats at Rollz Ice Cream!"
    },
    "surrey": {
      keywords: "desserts shop in Surrey, delicious dessert Surrey, dessert places Surrey, best dessert Surrey, popular dessert places in Surrey",
      title: "Desserts Surrey | Rolled Ice Cream, Falooda & More",
      description: "Discover Surreys best dessert shoprolled ice cream, waffles, faloodas, and more freshly made treats at Rollz!"
    },
    "vancouver": {
      keywords: " desserts shop in vancouver, delicious dessert vancouver, dessert places vancouver, best dessert vancouver, popular dessert places in vancouver.",
      title: "Desserts vancouver | Rolled Ice Cream, Waffles & More",
      description: "Discover vancouver’s go-to dessert shop at Lebovic! From faloodas to waffles and milkshakes, we serve it all at Rollz!"
    },
  }
  return (
    <>
      {/* <Helmet>
        <title>Rollz Ice Cream locations in Canada</title>
        <meta
          name="description"
          content="Find out Rollz at multiple locations, including Brampton, Ajax, Brantford, Collingwood, Edmonton, Guelph, Kitchener, Regina, Scarborough, Vaughan, Windsor, Mississauga, etc."
        />
        <meta
          property="og:title"
          content="Rollz Ice Cream locations in Canada"
        />
        <meta
          property="og:description"
          content="Find out Rollz at multiple locations, including Brampton, Ajax, Brantford, Collingwood, Edmonton, Guelph, Kitchener, Regina, Scarborough, Vaughan, Windsor, Mississauga, etc."
        />
      </Helmet> */}

      <Helmet>
        <meta
          name="keywords"
          content={metaData[localStorage.getItem("location_name")?.toLowerCase().replaceAll(",", "").replaceAll(" ", "-")]?.keywords}
        />
        <meta
          name="title"
          content={metaData[localStorage.getItem("location_name")?.toLowerCase().replaceAll(",", "").replaceAll(" ", "-")]?.title}
        />
        <meta
          name="description"
          content={metaData[localStorage.getItem("location_name")?.toLowerCase().replaceAll(",", "").replaceAll(" ", "-")]?.description}
        />
      </Helmet>

      {isLoading && <Loader />}
      <div className="locationsPage">
        {/* Hero Section  */}
        <section className="locations_hero">
          <div className="locations_img">
            <img
              src={locationData?.banner_bg_image}
              className="img-fluid"
              alt="Store Img"
            ></img>
          </div>
          <div className="locations_text">
            {locationData?.banner_title &&
              locationData?.banner_title !== "-" ? (
              <h3>{locationData?.banner_title}</h3>
            ) : (
              <h3>Treat Yourself With The</h3>
            )}
            {/* <h3>Treat Yourself With The</h3>
          <h3>Best Rolled Ice Cream Toronto</h3> */}
          </div>
        </section>

        {/* Timing Section  */}
        <section className="locations_timing_wrapper">
          <div className="container col-12 d-flex justify-content-between flex-column flex-sm-row">
            <div className="col-12 col-sm-6 d-flex flex-column justify-content-start align-items-center me-2 mb-4">
              <Card
                className="col-12 col-sm-12 d-flex flex-column justify-content-start border-0"
                // style={{ backgroundColor: "var(--primary-bg)" }}
                style={{
                  height: "450px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                  background: "white",
                }}
              >
                <h4
                  className="d-flex align-content-center justify-content-between p-3 border-radios-5 text-white"
                  style={{
                    backgroundColor: "var(--links-color)",
                    borderRadius: "5px",
                    fontFamily: "var(--heading-font)",
                  }}
                >
                  Our Menu
                </h4>
                <div
                  className={`d-flex locations_menuPage_items flex-column justify-content-start my-3 d-md-block `}
                  id="rolled-ice-cream"
                >
                  {categoryList
                    .filter((obj) => obj.subcategory !== 1)
                    .map((obj, i) => {
                      if (obj.is_active == 1) {
                        return (
                          <div key={i} className="px-2 py-1 locations_menu">
                            <p className="px-2 py-2">
                              <Link
                                to={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",", "")?.replaceAll(" ", "-")}/${obj.slug}`}
                                className="fw-bold text-capitalize d-flex justify-content-start align-items-center"
                                style={{ color: "var(--links-color)" }}
                              >
                                <img
                                  src={obj.url}
                                  className="me-3"
                                  style={{ width: "35px" }}
                                ></img>{" "}
                                {obj.menu_name}
                              </Link>
                            </p>
                          </div>
                        );
                      }
                    })}
                </div>
              </Card>
              {/* <div className="col-12 mt-4 d-flex flex-column align-items-center justify-content-center gap-4 locations_timing_chart">
                <div className="" style={{ maxWidth: "70%" }}>
                  <img src={StaticImg} alt="image" className="img-fluid" />
                </div>
              </div> */}
            </div>

            <div className="col-12 col-sm-6 d-flex flex-column align-items-start justify-content-start gap-4 locations_timing_container">
              <div className="col-12">
                <Map locations={mapLocation} height="450px" />
                <div className="col-12 d-flex flex-column flex-md-row justify-content-between align-items-center locations_address py-2 ps-2">
                  <div className="col-12 col-md-8">
                    <p className="mb-2 text-start">
                      {filteredLocations?.location_address &&
                        filteredLocations?.location_address !== "-"
                        ? filteredLocations?.location_address
                        : "NA"}
                    </p>
                  </div>
                  <div className="col-12 col-md-4 text-start text-md-end">
                    <Link
                      to={`${filteredLocations?.review_link} || "https://www.google.com/maps/place/Rollz+Ice+Cream+%26+Desserts/@43.4784711,-80.5257085,18z/data=!4m8!3m7!1s0x882bf3cf766e1161:0x6e8047d9f19537ac!8m2!3d43.4782899!4d-80.5248291!9m1!1b1!16s%2Fg%2F11vptgg7j6?hl=en&entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D" `}
                      target="_blank"
                      className=""
                    >
                      Get Direction <i className="bi bi-arrow-right"></i>
                    </Link>
                  </div>
                </div>
                <div className="col-12 ps-2 d-flex flex-column flex-md-row justify-content-between align-items-start">
                  {filteredLocations?.phone ? (
                    <div className="col-12 col-md-6 locations_contact py-2">
                      <div className="locations_weekdays_timing">
                        <a
                          href={`tel:${filteredLocations?.phone}`}
                          className="d-flex align-items-center location_contact justify-content-start"
                        >
                          <p className="">
                            <i className="bi bi-telephone-fill me-2"></i>
                            {filteredLocations?.phone}
                          </p>
                        </a>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {filteredLocations?.email ? (
                    <div className="col-12 col-md-6 locations_email py-2">
                      <div className="locations_weekdays_timing text-md-end">
                        <a href={`mailto: ${filteredLocations?.email}`}>
                          <p className="">
                            <i className="bi bi-envelope-fill me-2"></i>
                            {filteredLocations?.email}
                          </p>
                        </a>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="locations_order_online pb-3">
                  <div className="locations_weekdays_timing py-2 ps-2 d-flex flex-column flex-md-row">
                    {(filteredLocations?.order_link1 ||
                      filteredLocations?.order_link2 ||
                      filteredLocations?.order_link3) && (
                        <h5 className="mb-3 col-12 col-md-4">
                          <i className="bi bi-cart-check-fill me-1"></i> Order
                          Online
                        </h5>
                      )}

                    <div className="col-12 col-md-8 d-flex flex-sm-row align-items-center justify-content-start justify-content-md-end gap-3 order_types">
                      {filteredLocations?.order_link1 && (
                        <Link
                          to={`${filteredLocations?.order_link1} `}
                          target="_blank"
                        >
                          <img
                            src={doorImg}
                            alt=""
                            className="img-fluid order_link"
                          ></img>
                        </Link>
                      )}

                      {filteredLocations?.order_link2 && (
                        <Link
                          to={`${filteredLocations?.order_link2} `}
                          target="_blank"
                        >
                          <img
                            src={skipImg}
                            alt=""
                            className="img-fluid order_link"
                          ></img>
                        </Link>
                      )}

                      {filteredLocations?.order_link3 && (
                        <Link
                          to={`${filteredLocations?.order_link3}`}
                          target="_blank"
                        >
                          <img
                            src={uberImg}
                            alt=""
                            className="img-fluid order_link"
                          ></img>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mt-4 d-flex flex-column align-items-end justify-content-start gap-4 locations_timing_chart">
                {/* <div className="locations_header">
                  <Link
                    to={`${filteredLocations?.review_link} || "https://www.google.com/maps/place/Rollz+Ice+Cream+%26+Desserts/@43.4784711,-80.5257085,18z/data=!4m8!3m7!1s0x882bf3cf766e1161:0x6e8047d9f19537ac!8m2!3d43.4782899!4d-80.5248291!9m1!1b1!16s%2Fg%2F11vptgg7j6?hl=en&entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D"`}
                    target="_blank"
                  >
                    {filteredLocations?.location_name}
                  </Link>
                </div> */}

                {/* <div className="locations_address pb-3 text-end">
                  <p className="mb-2 text-end">
                    {filteredLocations?.location_address &&
                    filteredLocations?.location_address !== "-"
                      ? filteredLocations?.location_address
                      : "NA"}
                  </p>
                  <Link
                    to={`${filteredLocations?.review_link} || "https://www.google.com/maps/place/Rollz+Ice+Cream+%26+Desserts/@43.4784711,-80.5257085,18z/data=!4m8!3m7!1s0x882bf3cf766e1161:0x6e8047d9f19537ac!8m2!3d43.4782899!4d-80.5248291!9m1!1b1!16s%2Fg%2F11vptgg7j6?hl=en&entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D" `}
                    target="_blank"
                    className="text-end"
                  >
                    Get Direction <i className="bi bi-arrow-right"></i>
                  </Link>
                </div> */}

                {/* <div className="locations_contact pb-3">
                  <div className="locations_weekdays_timing text-end">
                    <h5 className="mb-2">
                      <i className="bi bi-telephone-fill me-1"></i> Mobile
                    </h5>
                    <a
                      href={`tel:${filteredLocations?.phone}`}
                      className="d-flex align-items-center location_contact justify-content-end"
                    >
                      <p className="">{filteredLocations?.phone}</p>
                    </a>
                  </div>
                </div> */}
                {/* <div className="locations_email pb-3">
                  <div className="locations_weekdays_timing text-end">
                    <h5 className="mb-2">
                      <i className="bi bi-envelope-open-fill me-1"></i> Email
                    </h5>
                    <a href={`mailto: ${filteredLocations?.email}`}>
                      <p className="">{filteredLocations?.email}</p>
                    </a>
                  </div>
                </div> */}
                {/* <div className="locations_order_online pb-3">
                  <div className="locations_weekdays_timing text-end">
                    {(filteredLocations?.order_link1 ||
                      filteredLocations?.order_link2 ||
                      filteredLocations?.order_link3) && (
                      <h5 className="mb-3">
                        <i className="bi bi-cart-check-fill me-1"></i> Order
                        Online
                      </h5>
                    )}

                    <div className="d-flex flex-sm-row align-items-center justify-content-start gap-3 order_types">
                      {filteredLocations?.order_link1 && (
                        <Link
                          to={`${filteredLocations?.order_link1} `}
                          target="_blank"
                        >
                          <img
                            src={doorImg}
                            alt=""
                            className="img-fluid order_link"
                          ></img>
                        </Link>
                      )}

                      {filteredLocations?.order_link2 && (
                        <Link
                          to={`${filteredLocations?.order_link2} `}
                          target="_blank"
                        >
                          <img
                            src={skipImg}
                            alt=""
                            className="img-fluid order_link"
                          ></img>
                        </Link>
                      )}

                      {filteredLocations?.order_link3 && (
                        <Link
                          to={`${filteredLocations?.order_link3}`}
                          target="_blank"
                        >
                          <img
                            src={uberImg}
                            alt=""
                            className="img-fluid order_link"
                          ></img>
                        </Link>
                      )}
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </section>

        {/* Branding Section  */}
        <section className="locations_branding_wrapper">
          <div className="container locations_branding_container">
            <div className="col-12 d-flex flex-column align-content-center justify-content-center locations_branding_section">
              {locationData?.branding_section_title &&
                locationData?.branding_section_title !== "-" ? (
                <p className="col-12 mb-4">
                  {locationData?.branding_section_title}
                </p>
              ) : (
                <p className="col-12 mb-4">
                  A cup full of happiness filled with Thai Rolled Ice Cream
                  Toronto awaits you. Not in the mood for ice cream; we have got
                  a lot of other dessert options.
                </p>
              )}

              <div className="col-12 d-flex flex-column flex-sm-row align-items-center justify-content-center gap-4 locations_branding_images mb-4">
                <div className="col-12 col-sm-5 brImg1">
                  <img
                    src={locationData?.branding_section_image1}
                    className="br1 img-fluid"
                    alt="branding Image 1"
                  ></img>
                </div>
                <div className="col-12 col-sm-5 brImg2">
                  <img
                    src={locationData?.branding_section_image2}
                    className="br2 img-fluid"
                    alt="branding Image 2"
                  ></img>
                </div>
              </div>
              {locationData?.branding_section_description &&
                locationData?.branding_section_description !== "-" ? (
                <p className="col-12">
                  {locationData?.branding_section_description}
                </p>
              ) : (
                <p className="col-12">
                  Too many options and have no idea what to try? How about we
                  give you a brief of what is the best that you can try at Roll
                  Me Up Ice Cream & Desserts? Check a list of our top sellers!
                </p>
              )}
            </div>
          </div>
        </section>

        {/* Products Show case Sction  */}
        <section className="locations_products_wrapper">
          <div className="container">
            {productsData.map((item) => (
              <div
                className="col-12 d-flex flex-column flex-sm-row align-items-start justify-content-center gap-4 locations_products_container mb-5"
                key={item.id}
              >
                <div className="col-12 col-sm-5 locations_products_img">
                  <img src={item.img} alt="product Img" className="img-fluid" />
                </div>
                <div className="col-12 col-sm-7 locations_products_info">
                  <h3 className="mb-3">{item.title}</h3>
                  <p>{item.info}</p>
                </div>
              </div>
            ))}
            <div className="products_menu_btn">
              <OrderBtn text="View Menu" url="/menu" />
            </div>
          </div>
        </section>

        <Testimonials testimonialsList={testimonialsList} />

        {/* <Footer color="#ffecf0" /> */}
      </div>
    </>
  );
};

export default LocationsPage;
